import { render, staticRenderFns } from "./sign-in.vue?vue&type=template&id=a55d1bf6&scoped=true&"
import script from "./sign-in.vue?vue&type=script&lang=js&"
export * from "./sign-in.vue?vue&type=script&lang=js&"
import style0 from "./sign-in.vue?vue&type=style&index=0&id=a55d1bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55d1bf6",
  null
  
)

export default component.exports